module.exports = __webpack_public_path__ + "img/404.504f7fa2.png";